export default "__VITE_ASSET__BiecpGEW__"